export const getMedian = (numbers: number[]) => {
  const sorted = numbers
    .slice()
    .filter((a: number) => a > 0)
    .sort((a: number, b: number) => a - b)
  const middle = Math.floor(sorted.length / 2)
  if (sorted[middle] > 95) {
    return 95
  }
  if (sorted[middle] < 5) {
    return 5
  }
  if (sorted.length % 2 === 0) {
    return (sorted[middle - 1] + sorted[middle]) / 2
  }
  return sorted[middle]
}

export const getMinAndMax = (numbers: number[], median: number) => {
  const max = Math.max(...numbers)
  const min = Math.min(...numbers)
  const maxMinusMedian = max - median
  const medianMinusMin = median - min

  let minimum
  let maximum
  let range

  if (maxMinusMedian > medianMinusMin) {
    range = Math.ceil(maxMinusMedian / 5) * 5
  } else {
    range = Math.floor(medianMinusMin / 5) * 5
  }
  if (median - range < 0) {
    minimum = 0
    maximum = median + median
  } else if (median + range > 100) {
    maximum = 100
    minimum = median - (100 - median)
  } else if (range > 0) {
    minimum = median - range
    maximum = median + range
  } else {
    minimum = median - 5
    maximum = median + 5
    return {minimum, maximum, range: 5}
  }
  return {minimum, maximum, range}
}
